<template><span class="exhibition-title-parts"><span v-for="(part,index) in parts" :key="index" :class="{'exhibition-title-subtitle':index>0}">{{part}}</span></span></template>
<script>
import { exhibitionTitleParts } from '../../utils/exhibitionTypography';
export default {props:{text:{type:String,default:''}},computed:{parts(){return exhibitionTitleParts(this.text);}}};
</script>
<style scoped>
.exhibition-title-parts>span {display:block;text-wrap:pretty;}
.exhibition-title-subtitle {margin-top:.24em;font-size:.88em;line-height:1.3;}
</style>
